import { DASHBOARD_APIS_DATA } from "../types";

export const setSelectedDashboardApisData = (selectDashboardApisData: any) => {
  return {
    type: DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_SET_SELECTED,
    payload: {...selectDashboardApisData}
  }
}

export const clearSelectedDashboardApisData = () => {
  return {
    type: DASHBOARD_APIS_DATA.DASHBOARD_APIS_DATA_CLEAR_SELECTED
  }
}
